import type { AppContext, AppRouteConfig, RouteKey } from "@/core/constants";
import { APP_ROUTES } from "@/core/constants";

import type { AppRouteDefinition } from "./types";

export const APP_ROUTE_LIST: readonly AppRouteConfig[] = [
  APP_ROUTES.auth.signIn,
  APP_ROUTES.root,
  APP_ROUTES.superAdmin.dashboard,
  APP_ROUTES.superAdmin.tenants,
  APP_ROUTES.superAdmin.plans,
  APP_ROUTES.superAdmin.library.index,
  APP_ROUTES.superAdmin.library.verticals,
  APP_ROUTES.superAdmin.library.categories,
  APP_ROUTES.superAdmin.library.review,
  APP_ROUTES.superAdmin.library.templates,
  APP_ROUTES.superAdmin.library.packs,
  APP_ROUTES.superAdmin.accessPresets,
  APP_ROUTES.superAdmin.auditLog,
] as const;

export const APP_ROUTE_BY_KEY = Object.fromEntries(
  APP_ROUTE_LIST.map((route) => [route.key, route]),
) as Record<RouteKey, AppRouteConfig>;

export function flattenAppRoutes(
  routes: readonly AppRouteDefinition[],
): readonly AppRouteDefinition[] {
  return routes.flatMap((route) => [
    route,
    ...flattenAppRoutes(route.children ?? []),
  ]);
}

export function getContextFromPath(_pathname: string): AppContext {
  return "super-admin";
}

export function getRouteByKey(routeKey: RouteKey): AppRouteConfig {
  return APP_ROUTE_BY_KEY[routeKey];
}

export const routeBuilders = {
  superAdminPackDetail: (packId: string) =>
    `${APP_ROUTES.superAdmin.library.packs.path}/${packId}`,
} as const;

export function isRouteActive(
  pathname: string,
  route: AppRouteConfig,
): boolean {
  if (pathname === route.path || pathname.startsWith(`${route.path}/`)) {
    return true;
  }

  return (
    route.children?.some((childKey) =>
      isRouteActive(pathname, getRouteByKey(childKey)),
    ) ?? false
  );
}
